import { gql } from '@apollo/client';

export default gql`
  query PDFDownloadQuery($pdfName: String!, $reportType: String!) {
    pdfDownloadQuery(pdfName: $pdfName, reportType: $reportType)
  }
`;
